import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '../../hooks/useApiClient'
import type { components } from '../../types/api/v1'

// Use the API schema for PriceBreakdownResp
export type PriceBreakdownResponse = components['schemas']['PriceBreakdownResp']

export function usePriceBreakdown() {
  const $api = useApiClient()

  const getPriceBreakdownById = (price_id: string | null) => {
    // More strict validation - only enable if we have a non-empty, non-null price_id
    const isValidPriceId = Boolean(price_id && typeof price_id === 'string' && price_id.trim().length > 0)

    return $api.useQuery('post', '/supplier_rec/price/breakdown', {
      body: undefined, // POST endpoint with query params
      enabled: isValidPriceId,
      refetchOnWindowFocus: false,
      retry: false, // Don't retry failed requests automatically
      params: {
        query: {
          price_id: isValidPriceId ? price_id! : '', // Only send actual price_id when valid
        },
      },
    })
  }

  return { getPriceBreakdownById }
}
